import * as React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
interface IProps {
  businessLines: any[]
  factoid: any
}

const Container = styled('span')<{expands: boolean}>`
  float: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  transition: max-height 0.7s;
  max-height: 600px;
  overflow: hidden;
  ${cprops => cprops.expands ? '' : 'max-height:30px;'}
`
const Expand = styled.span`
  background-color: white;
  margin: 4px;
  padding: 8px;
  padding-bottom: 16px;
  float: right;
  line-height: 0;
  border: 1px solid rgb(181,181,181);
  cursor: pointer;
  background-color: #e0e0e0;
  color: rbg(86,86,86);
`

const ContainerSlant = styled('div')<{backCol: string}>`
      float: right;
      text-align: end;
      font-size: 13px;
      position: relative;
      display: inline-block;
      overflow: hidden;
      color: #fff;
      padding: 0.4em 2em 0.4em 2.5em;
      margin-top: 0.5em;
      &:after {
        padding: 0.4em 2em 0.4em 4.5em;
        background-color: ${props => props.backCol};
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        -webkit-transform-origin: 100% 0;
        -ms-transform-origin: 100% 0;
        transform-origin: 100% 0;
        -webkit-transform: skew(25deg);
        -ms-transform: skew(25deg);
        transform: skew(25deg);
        z-index: 1;
      }
    `

const CardChip = (props: IProps) => {
  // Get factoids related BL's
  // Grab the first one and use that info for the chip
  // const businessLine =
  //   factoidBusinessLines.length > 0
  //     ? props.businessLines.find(
  //         (bizline: any) => bizline.id === factoidBusinessLines[0]
  //       )
  //     : {}
  const [expand, setExpand] = React.useState(false)
  const factoidBusinessLines = props.factoid.business_line
  const lineItems = [
    ...props.businessLines.filter(val => factoidBusinessLines.includes(val.id))
  ]
  const Items = lineItems.map((businessLine: any) => {
    if(lineItems.length > 1) {
      console.log(JSON.stringify(businessLine)) 
    }
    
    const businessLineLabel = businessLine.name || 'No BL attached'
    const businessLineColor = businessLine.acf
      ? businessLine.acf.chip_colour
      : '#000'
    
    const TextSpan = styled.span`
      position: relative
      z-index: 2;
    `
    return (
      <>
        <ContainerSlant backCol={businessLineColor}>
          
          <TextSpan>{businessLineLabel}</TextSpan>
        </ContainerSlant>
      </>
    )
  })
  const handleExpand = () => {
    setExpand(prev => !prev)
  }
  return (
    <Container expands={(expand || Items.length === 1)} >
      {Items.length === 1 && Items}
      {Items.length > 1 && (
        <>
        <Expand onClick={handleExpand}> ... </Expand>
        {Items}
        </>
      )}
      
    </Container>
  )
}

export default connect(
  (state: any) => ({
    businessLines: state.data.businessLines
  }),
  null
)(CardChip)



// WEBPACK FOOTER //
// ./src/shared/CardChip.tsx